const { databaseServer } = require('../config/network');

const getUsers = async (token, collectionId) => {
    return fetch(`${databaseServer}/users`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const getUsersById = async (token, id) => {
    return fetch(`${databaseServer}/users/${id}`,{
        headers: new Headers({
            'Authorization': token
        })})
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const createUser = async (token, user) => {
    return fetch(`${databaseServer}/users`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(user),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

// P1-20: reset another user's password. The server decides whether this is allowed
// (Manager+, and not on a user at or above your own role) and returns 403
// PASSWORD_RESET_FORBIDDEN if not -- the UI hides the control, but a stale tab can
// still reach the route.
const resetUserPassword = async (token, userId, password) => {
    return fetch(`${databaseServer}/users/${userId}/password`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({password}),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const editUserOnDb = async (token, user) => {
    return fetch(`${databaseServer}/users/${user.id}`, {
        method: 'put',
        mode: 'cors',
        body: JSON.stringify(user),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const deleteUserFromDb = async (token, id) => {
    return fetch(`${databaseServer}/users/${id}`, {
        method: 'delete',
        mode: 'cors',
        headers: new Headers({
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    getUsers,
    getUsersById,
    createUser,
    resetUserPassword,
    deleteUserFromDb,
    editUserOnDb,
}